import { omrehBaseClient } from "./client";

const FlightConsistencyByCountryDropDown = (country) => {
  return omrehBaseClient
    .get("/Station/FlightConsistencyByCountryDropDown", {
      params: {
        'country': country
      }
    });
}

const StationConsistencyByCountryDropDown = () => {
  return omrehBaseClient
    .get("/Province/StationConsistencyByCountryDropDown", {
      params: {
        
      }
    });
}

const stationApi = {
   FlightConsistencyByCountryDropDown, StationConsistencyByCountryDropDown
}

export default stationApi